import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"container\" data-v-6fdaa934><div class=\"back side\" data-v-6fdaa934></div><div class=\"left side\" data-v-6fdaa934></div><div class=\"right side\" data-v-6fdaa934></div><div class=\"top side\" data-v-6fdaa934></div><div class=\"bottom side\" data-v-6fdaa934></div><div class=\"front side\" data-v-6fdaa934></div></div>", 1)
  ]))]))
}